import styled from 'styled-components';

export const StyledMobileInputContainer = styled.div<{ value: string }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 290px;
  border-bottom: ${({ theme }): string => theme.borders[0]};
  border-color: ${({ theme, value }): string =>
    !value.length ? theme.colors.minorText : theme.colors.normalText};
  padding-bottom: 8px;
  margin: auto;
`;

export const StyledInput = styled.input`
  font-family: AliBabaRE;
  border: none;
  display: flex;
  width: 282px;
  background-color: transparent;
  font-size: 24px;
  letter-spacing: 0.4em;
  outline: none;
  color: ${({ theme }): string => theme.colors.normalText};

  ::placeholder {
    color: ${({ theme }): string => theme.colors.minorText};
  }
`;
